module.exports = __webpack_public_path__ + "img/taiyo5s.32b53728.gif";